import React, {useContext, useEffect, useState} from 'react';

import Button from "components/Button/Button";
import styleCom from "./REGCOM.module.scss";
import DataGrid from "../../components/DataGrid/DataGrid";
import {postData} from 'utils/TransactionUtil';
import Modal from "../../components/Modal/Modal";
import REG300M3 from "./REG300M3";
import cdmInfoData from "../../assets/json/frmFront_loadData.json";
import InputUnitText from "../../components/InputText/InputUnitText";
import TextArea from "../../components/TextArea/TextArea";
import RadioGroup from "../../components/Radio/RadioGroup";
import toast from "../../components/Toast/Toast";
import {AuthContext} from "../../contexts/AuthContext";  //수동쿼리 등록창 팝업


const REG300M2 = ({handle_Close, mstId, hsptCd, comHandleClick_Save}) => {

    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기
    const [isManager, setIsManager] = useState(
        (userInfo.roleId === '200001' || userInfo.roleId === '300001')
    );
    const [isDisableCurrent, setIsDisableCurrent] = useState(true);

    const [isModalOpen_regMst, setIsModalOpen_regMst] = useState(false); //모달 오픈여부

    const workMstId  = mstId;
    const workHsptCd = hsptCd;
    const [rows_mstList, setRows_mstList] = useState([]);
    const cols_mstList = [
        { key: 'subjectCd',       name: 'Subject No.',  width: '20%' },
        { key: 'reviewId',        name: 'Seq',  width: '10%' },
        { key: 'reviewTitle',     name: '제목',  width: '50%' , cellClass: 'align_left'},
        { key: 'currentStatusNm', name: '현재상태',  width: '20%' },
        { key: 'reviewRegYmd',    name: '작성일', width: '20%' }

    ];
    const [rows_dtlList, setRows_dtlList] = useState([]);
    const cols_dtlList = [
        { key: 'reviewIdSeq',   name: 'No.',    width: '20%' },
        { key: 'reviewUserNm',  name: '등록자',  width: '30%' },
        { key: 'reviewStatusNm',name: '상태이력', width: '20%' },
        { key: 'reviewTime',    name: '작성일시', width: '30%' }
    ];

    /* 컴포넌트 세팅 정보 */
    const [selectDtlNote, setSelectDtlNote] = useState('');
    const radioOptions = [
         {mapCd: 'reviewStatus', value: "A", label: "확인요청"}
        ,{mapCd: 'reviewStatus', value: "B", label: "작업완료"}
        ,{mapCd: 'reviewStatus', value: "C", label: "최종(확인) 완료"}
    ];
    function getOptionList(cdValue) {
        return radioOptions.filter(option => option.mapCd === cdValue);
    }
    const [reviewStatus, setReviewStatus] = useState('');
    const [currentStatus, setCurrentStatus] = useState('');
    const [reviewNote, setReviewNote] = useState('');
    //상세내용 신규등록 관련
    const [dsAddObj, setDsAddObj] = useState({
        mstId:"", reviewId:"", currentStatus:"" ,reviewNote:""
    });
    const setDsAddValue = (name, value) => {
        setDsAddObj(prev => ({
            ...prev,
            [name]: value
        }));
    }
    const initAddObj = ()=>{
        setDsAddObj({
            mstId:"", reviewId:"", currentStatus:"",reviewNote:""
        })
    }


    /* *********************************************************  컴포넌트 세팅 */

    /*   Form Load ================================================================= */
    useEffect(() => {
        getReviewMst();
    }, []);


    /* *********************************************************  Form Load 종료 */

    /* Call Service================================================================= */
    async function getReviewMst(){
        initAddObj();

        //메인 데이터 조회
        const param = { mstId:workMstId, hsptCd:workHsptCd};
        const res = await postData("/REW/getReviewMst", param);
        setRows_mstList(res);

    }
    async function getReviewDtl(workReviewId){
        setRows_dtlList([]);
        initAddObj();

        //상세 데이터 조회
        const paramDtl = { mstId:workMstId, hsptCd:workHsptCd, reviewId:workReviewId};
        const res = await postData("/REW/getReviewDtl", paramDtl);
        setRows_dtlList(res);
        setSelectDtlNote('');
    }

    async function svcAddQuery() {
        let param;
        param = dsAddObj;
        let result = await postData("/REW/setReviewDtlAdd", param);

        if(result===1){
            toast({ type: 'info', message: '등록이 완료되었습니다.'});
            handle_Close(true);
        }else{
            toast({ type: 'error', message: '등록이 실패하였습니다.'});
            handle_Close(false);
        }
    }
    /* ============================================================== Call Service 종료  */

    /* EVENT ============================================================================*/

    //Current Status - role 에 따라서 선택제어
    const onChange_status = (name, value) => {
        //dsAddObj.currentStatus

        if(isManager){
            if(value === 'B'){
                toast({ type: 'warning', message: '확인요청 / 최종완료만 선택 가능합니다.'});
            }else{
                setDsAddValue(name, value);
            }
        }else{
            if(value !== 'B'){
                toast({ type: 'warning', message: '작업 완료 상태만 선택 가능합니다.'});
            }else{
                setDsAddValue(name, value);
            }
        }

    }


    //MST 조회
    const handleClick_schMst = () => {
        getReviewMst();
    }
    //Query 등록팝업 호출(제목)
    const handleClick_regMst = () => {
        if(isManager){
            handleModalOpen_regMst();
        }else{
            toast({ type: 'warning', message: 'PI / CRA 경우에만 등록 가능합니다.'});
        }

    }

    ////Query 상태값 변경
    const handlechange_status = (e) => {
        setSelectDtlNote(e.row.reviewNote);

    }
    //Query 추가등록
    const handleClick_addDtlQuery = () => {

        if(isDisableCurrent){
            toast({ type: 'info', message: '선택된 쿼리가 없습니다.'});
        }else if(isManager){
            if(dsAddObj.currentStatus==='B') {
                toast({ type: 'warning', message: '확인요청 / 최종완료만 선택 가능합니다.'});
            }else{
                svcAddQuery();
            }
        }else{
            if(dsAddObj.currentStatus==='B'){
                svcAddQuery();
            }
            if(dsAddObj.currentStatus==='A'){
                toast({ type: 'info', message: '상태값을 확인하여 주십시오.'});
            }else if(dsAddObj.currentStatus==='C'){
                toast({ type: 'info', message: '완료처리 권한이 없습니다.'});
            }
        }

    }


    //MST 데이터 클릭
    const handleClick_mstGrid_row = (e) => {
        //console.log(e.row.mstId + ' / ' + e.row.reviewId)
        //console.log("e.row : " + e.row.reviewId);
        if(e.row.reviewId !== null || e.row.reviewId !== "" ){
            setIsDisableCurrent(false);
        }else{
            setIsDisableCurrent(true);
        }

        getReviewDtl(e.row.reviewId);
        initAddObj();
        setDsAddValue("mstId",e.row.mstId);
        setDsAddValue("reviewId",e.row.reviewId);
        setDsAddValue("currentStatus",e.row.currentStatus);
    }

    //MST 등록팝업 닫기
    const handleModalOpen_regMst = () => {
        setIsModalOpen_regMst(true);
    }
    const handleModalClose_regMst = (isRefresh=false) => {
        setIsModalOpen_regMst(false);
        if(isRefresh){
            handleClick_schMst();
        }

    }
    //DTL 데이터 클릭
    const handleClick_DtlGrid_row = (e) => {
        //console.log(e.row.mstId + ' / ' + e.row.reviewId)
        setSelectDtlNote(e.row.reviewNote);
    }


    return(
    <>
        <div className={styleCom.main_wrap}>
            <div>
                <table width={"100%"} style={{height: "100%", display: "flex", justifyContent: "center"}}>
                        <tbody>
                        <tr>
                            <td width={"700px"}>
                                    <Button variant="Primary" size="md" addStyle={{width: "500px", height: "35px"}}
                                            onClick={() => handleClick_regMst()}>
                                        Query 신규등록
                                    </Button>
                                <div style={{marginTop: "10px", height: "200px", width: "500px"}}>
                                    <DataGrid
                                        cols={cols_mstList}
                                        rows={rows_mstList}
                                        rowHeight={37}
                                        // onCellDoubleClick={(e) => handleDoubleClick_DataGrid_row(e)}
                                        onCellClick={(e) => handleClick_mstGrid_row(e)}
                                        sortable={true}
                                        isNodataView={true}
                                    />
                                </div>
                                <div style={{marginTop: "10px", height: "200px", width:"500px"}}>
                                    <DataGrid
                                        cols={cols_dtlList}
                                        rows={rows_dtlList}
                                        rowHeight={37}
                                        // onCellDoubleClick={(e) => handleDoubleClick_DataGrid_row(e)}
                                        onCellClick={(e) => handleClick_DtlGrid_row(e)}
                                        sortable={true}
                                        isNodataView={true}
                                    />
                                </div>
                                <div>

                                    <div className={styleCom.title_wrap} style={{marginBottom: "10px"}}>
                                        <h3>View Query Details</h3>
                                    </div>
                                    <TextArea width={'500px'} height={'150px'} readOnly={true}
                                              value={selectDtlNote}/>
                                </div>
                            </td>
                            <td width={"600px"} style={{verticalAlign: "top"}}>


                                <div>
                                    <div className={styleCom.title_wrap} style={{marginBottom: "10px"}}>
                                        <h3>Current Status</h3>
                                    </div>
                                    <RadioGroup options={getOptionList('reviewStatus')}
                                                selectedValue={dsAddObj.currentStatus} marginLeft={"20px"}
                                                onChange={(val) => onChange_status("currentStatus", val)}
                                                disabled={isDisableCurrent}
                                    />

                                    <div className={styleCom.title_wrap}
                                         style={{marginTop: "20px", marginBottom: "20px"}}>
                                        <h3>Add Details</h3>
                                    </div>
                                    <TextArea width={'500px'} height={'150px'} margin={"0px 0px 20px 0px"}
                                              value={dsAddObj.reviewNote} maxLength={300}
                                              onChange={(val) => setDsAddValue("reviewNote", val)}/>
                                    <Button variant="Secondary" size="md" addStyle={{width: "500px", height: "35px"}}
                                            onClick={() => handleClick_addDtlQuery()}>
                                        저장 (상세내역 등록)
                                    </Button>

                                </div>
                            </td>
                        </tr>
                        </tbody>
                </table>
            </div>


        </div>
        <Modal
            open={isModalOpen_regMst}
            handle_Close={handleModalClose_regMst}
            title="Manual Raise a Query"
            width="800px"
            height="800px"
            isHeader={true}
            bottomBtnText={{cancel: "취소", confirm: "저장"}}
            isBottom={true}>
            <REG300M3 handle_Close={handleModalClose_regMst} mstId={workMstId} hsptCd={workHsptCd}/>
        </Modal>
    </>
    )
}
export default REG300M2;